import { MyMedicTMAction } from "./mymedic.tm.types";

export const myMedicTMRequestAction = (): MyMedicTMAction => ({ type: 'MYMEDIC_TM_REQUEST' })
export const myMedicTMSuccessAction = (params: { disabled: boolean }): MyMedicTMAction => ({ type: 'MYMEDIC_TM_SUCCESS', params })
export const myMedicTMFailureAciton = (error?: any): MyMedicTMAction => ({ type: 'MYMEDIC_TM_FAILURE', params: error })